const JUNK_URL_PATTERNS = ["photo", "image", "img", "gallery", "picture", "flickr", "instagram.com", "pinterest.com", "imgur.com", "shutterstock",
  "gettyimages", "alamy", ".jpg", ".jpeg", ".png", ".gif", ".webp", "youtube.com/watch", "tiktok.com", "yelp.com", "tripadvisor"];

const isJunkUrl = (url) => url && JUNK_URL_PATTERNS.some((p) => url.toLowerCase().includes(p));
const toArray = (v) => (Array.isArray(v) ? v : v ? [v] : []);
const trimDots = (s) => s.replace(/\s*\.{3,}$/, "").trim();

const isUsefulIntel = (item) => {
  if (typeof item !== "object") return true;
  if (item.url && isJunkUrl(item.url)) return false;
  return !(item.text && item.text.trim().length < 20);
};

export const feedbackContextFor = (lead, index) => ({
  leadIndex: index,
  kind: "lead",
  companyName: lead.companyName || lead.company || null,
  personTitle: lead.personTitle || lead.contactTitle || null,
  sources: Array.isArray(lead.sources) ? lead.sources.filter((s) => typeof s === "string") : lead.sourceId ? [lead.sourceId] : [],
  leadId: lead.leadId || null,
});

export const icpScoreOf = (icpMatch) => (icpMatch ? (typeof icpMatch === "object" ? icpMatch.score : icpMatch) : null);

export const icpColorOf = (icpMatch) => {
  if (!icpMatch) return "bg-gray-500/20 text-gray-400 border-gray-500/30";
  const score = icpMatch.score || icpMatch;
  if (score >= 70) return "bg-green-500/20 text-green-400 border-green-500/30";
  if (score >= 50) return "bg-amber-500/20 text-amber-400 border-amber-500/30";
  return "bg-red-500/20 text-red-400 border-red-500/30";
};

// One normalised view of a lead from any source (Hunt, Farm, Stream, CRM) with fallbacks for every field name variant.
export const normalizeLead = (lead, refreshedIntel) => {
  const isFirmOnly = !lead.personName && !lead.contactName && !!(lead.registry || lead.entityType === "company" || lead.companyFacts?.length);
  const rawTitle = isFirmOnly
    ? lead.companyFacts?.[0] || "Verified firm — decision-maker not yet identified"
    : lead.personTitle || lead.contactTitle || lead.title?.split(" - ")[1] || "";
  const businessIntel = refreshedIntel?.news || lead.businessIntel || lead.businessIntelligence || [];
  return {
    isFirmOnly,
    name: isFirmOnly ? lead.companyName || lead.company || "Verified firm" : lead.personName || lead.contactName || lead.name || lead.title?.split(" - ")[0] || "Unknown",
    title: rawTitle.replace(/\s*\.{3,}$/, "").replace(/\s+at\s*\.{0,3}$/, "").trim(),
    company: trimDots(isFirmOnly ? "" : lead.companyName || lead.company || ""),
    companyFacts: Array.isArray(lead.companyFacts) ? lead.companyFacts.slice(isFirmOnly ? 1 : 0, isFirmOnly ? 4 : 3) : [],
    registry: lead.registry || null,
    email: lead.email || lead.contactEmail || null,
    emailConfidence: lead.emailConfidence || null,
    icpScore: icpScoreOf(lead.icpMatch || null),
    icpColor: icpColorOf(lead.icpMatch || null),
    fitReasons: toArray(lead.whyGoodFit || lead.reasons || []),
    linkedinUrl: lead.linkedinUrl || lead.url || null,
    intelItems: toArray(businessIntel).filter(isUsefulIntel),
    website: lead.website || lead.companyUrl || null,
    industry: lead.industry || lead.companyIndustry || null,
    location: lead.location || lead.companyLocation || null,
    expansionAngle: lead.expansionAngle || null,
    signals: refreshedIntel?.signals || [],
  };
};
